import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import axios from "axios";
import "./Overview.css";

export default function Overview(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coordinates,
      temperature: response.data.temperature.current,
      wind: response.data.wind.speed,
      humidity: response.data.temperature.humidity,
      city: response.data.city,
      date: new Date(response.data.time * 1000),
      description: response.data.condition.description,
      icon: response.data.condition.icon,
    });
    console.log(response.data.condition.icon);
  }

  function search() {
    const currentWeatherApiKey = process.env.REACT_APP_CURRENT_WEATHER_API_KEY;
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${currentWeatherApiKey}&units=imperial
    `;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <section className="Overview" aria-label="Overview">
        <header>
          <form onSubmit={handleSubmit} className="form-inline">
            <div className="form-container row">
              <div className="col-12 d-flex">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter a city..."
                  onChange={handleCityChange}
                />
                <button>
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
            </div>
          </form>
        </header>
        <WeatherInfo data={weatherData} />
        <WeatherForecast coordinates={weatherData.coordinates} />
      </section>
    );
  } else {
    search();
  }
}
